export default "__VITE_ASSET__B75i8RHN__"